import ImageViewer from "./viewers/ImageViewer";
import PdfViewer from "./viewers/PdfViewer";
import DocxViewer from "./viewers/DocxViewer";
import TextViewer from "./viewers/TextViewer";
import ExcelViewer from "./viewers/ExcelViewer";
import CsvViewer from "./viewers/CsvViewer";
import UnknownViewer from "./viewers/UnknownViewer";
import { FileKind } from "./detect";
import DocxOcrViewer from "./viewers/DocxOcrViewer";
import AudioViewer from "./viewers/AudioViewer";

export const viewerFor: Record<FileKind, React.FC<any>> = {
  image: ImageViewer,
  pdf: PdfViewer,
  docx: DocxViewer,
  // docx: DocxOcrViewer,
  text: TextViewer,
  excel: ExcelViewer,
  csv: CsvViewer,
  audio: AudioViewer,
  unknown: UnknownViewer,
};